"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

var _semanticUiReact = require("semantic-ui-react");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Question = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(Question, _React$Component);

  function Question() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_this), "state", {
      active: false,
      isOpen: false
    });

    _defineProperty(_assertThisInitialized(_this), "toggleActive", function (e) {
      _this.setState(_extends({}, _this.state, {
        active: !_this.state.active
      }));
    });

    _defineProperty(_assertThisInitialized(_this), "handleAnswerClick", function (answer) {
      var question = _this.props.value;

      var selected = _this.props.selectedCharacteristics.characteristics.find(function (value) {
        return value.answerId === answer.answerId;
      });

      var characteristic = {
        answerId: answer.answerId,
        questionId: question.questionId,
        answerLabel: answer.answerLabel,
        questionLabel: question.questionLabel
      };

      if (selected) {
        _this.props.removeSelectedCharacteristic(characteristic);
      } else {
        _this.props.addSelectedCharacteristic(characteristic);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleQuestionClick", function (isChecked) {
      var _this$props = _this.props,
          question = _this$props.value,
          addSelectedCharacteristic = _this$props.addSelectedCharacteristic,
          removeSelectedCharacteristic = _this$props.removeSelectedCharacteristic;

      if (isChecked) {
        question.answers.map(function (answer) {
          return removeSelectedCharacteristic(answer);
        });
      } else {
        // only add the characteristic if it doesn't currently exist in the selectedCharacteristics redux collection
        // filter the question.answers array to remove those that already exist in the selectedCharacterists
        // then map that to add the remaining
        question.answers.filter(function (answer) {
          return !_this.props.selectedCharacteristics.characteristics.find(function (selectedChar) {
            return selectedChar.answerId === answer.answerId;
          });
        }).map(function (answer) {
          // when adding the characteristic the whole object needs to be put in
          var characteristic = {
            answerId: answer.answerId,
            questionId: question.questionId,
            answerLabel: answer.answerLabel,
            questionLabel: question.questionLabel
          };
          return addSelectedCharacteristic(characteristic);
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "isGroupChecked", function (question) {
      var checkedArr = _this.props.selectedCharacteristics.characteristics.filter(function (selectedArr) {
        return selectedArr.questionId === question.questionId;
      });

      return checkedArr.length === question.answers.length;
    });

    _defineProperty(_assertThisInitialized(_this), "isPartiallySelected", function (question) {
      var checkedArr = _this.props.selectedCharacteristics.characteristics.filter(function (selectedArr) {
        return selectedArr.questionId === question.questionId;
      });

      return checkedArr.length > 0 && checkedArr.length < question.answers.length;
    });

    _defineProperty(_assertThisInitialized(_this), "handleShowHide", function () {
      _this.setState({
        isOpen: !_this.state.isOpen
      });
    });

    return _this;
  }

  var _proto = Question.prototype;

  //to allow collapse the questions if clear btn clicked
  _proto.componentDidUpdate = function componentDidUpdate() {
    if (this.props.shouldReset && this.state.active === true) {
      this.setState(_extends({}, this.state, {
        active: false
      }));
    }
  };

  _proto.render = function render() {
    var _this2 = this;

    var _this$props2 = this.props,
        question = _this$props2.value,
        selectedCharacteristics = _this$props2.selectedCharacteristics,
        _this$props2$hasAcces = _this$props2.hasAccess,
        hasAccess = _this$props2$hasAcces === void 0 ? true : _this$props2$hasAcces,
        noAccessAction = _this$props2.noAccessAction,
        categoryLabel = _this$props2.categoryLabel;
    var _this$state = this.state,
        active = _this$state.active,
        isOpen = _this$state.isOpen;
    var isChecked = this.isGroupChecked(question);
    var isPartial = this.isPartiallySelected(question);
    var answerDefault = 10;
    var answerLimit = isOpen ? undefined : answerDefault;
    var answersTotal = question.answers.length;
    return /*#__PURE__*/React.createElement("li", {
      className: "characteristics-filter-question"
    }, /*#__PURE__*/React.createElement(_semanticUiReact.Accordion, {
      active: active ? 'true' : 'false',
      className: "characteristics-filter__accordion"
    }, /*#__PURE__*/React.createElement(_semanticUiReact.Accordion.Title, {
      className: "characteristics-filter-question__title"
    }, /*#__PURE__*/React.createElement(_semanticUiReact.Checkbox, {
      className: "characteristics-filter-question__checkbox",
      value: question.questionId,
      onClick: function onClick() {
        return hasAccess ? _this2.handleQuestionClick(isChecked) : noAccessAction(categoryLabel);
      },
      checked: isChecked,
      indeterminate: isPartial
    }), /*#__PURE__*/React.createElement("button", {
      onClick: this.toggleActive,
      className: "characteristics-filter__button"
    }, /*#__PURE__*/React.createElement("span", {
      className: "characteristics-filter__question-label"
    }, question.questionLabel), /*#__PURE__*/React.createElement(_semanticUiReact.Icon, {
      className: "characteristics-filter__button-icon",
      name: "" + (active ? 'minus square outline' : 'plus square outline')
    }))), /*#__PURE__*/React.createElement(_semanticUiReact.Accordion.Content, {
      active: active
    }, /*#__PURE__*/React.createElement("ul", {
      className: "characteristics-filter__answer-list"
    }, question && question.answers && question.answers.slice(0, answerLimit).map(function (answer, key) {
      return /*#__PURE__*/React.createElement("li", {
        key: key,
        className: "characteristics-filter-answer"
      }, /*#__PURE__*/React.createElement(_semanticUiReact.Checkbox, {
        onClick: function onClick() {
          return hasAccess ? _this2.handleAnswerClick(answer) : noAccessAction(categoryLabel);
        },
        checked: selectedCharacteristics.characteristics.find(function (value) {
          return value.answerId === answer.answerId;
        }) ? true : false,
        className: "characteristics-filter-answer__checkbox",
        "data-canonical-name": answer.answerLabel,
        value: answer.answerId,
        label: answer.answerLabel
      }));
    }), answersTotal > answerDefault && /*#__PURE__*/React.createElement("li", {
      className: "characteristics-filter-answer"
    }, /*#__PURE__*/React.createElement("button", {
      className: "characteristics-filter-answer__show-more",
      onClick: this.handleShowHide
    }, isOpen ? /*#__PURE__*/React.createElement(React.Fragment, null, "Show less\u2026") : /*#__PURE__*/React.createElement(React.Fragment, null, "Show more\u2026")))))));
  };

  return Question;
}(React.Component);

exports["default"] = Question;